import { httpClient } from '@/services/http/httpClient'

import type { ScoreParameters } from '../types'

type Params = {
  [key in ScoreParameters]: number
}

export async function updateScores({
  ideaCoCreationWeight,
  ideaCommentWeight,
  ideaCreationWeight,
  ideaImplementWeight,
  ideaSelectWeight,
}: Params) {
  const payload = {
    idea_creation_weight: ideaCreationWeight,
    idea_select_weight: ideaSelectWeight,
    idea_co_creation_weight: ideaCoCreationWeight,
    idea_implement_weight: ideaImplementWeight,
    idea_comment_weight: ideaCommentWeight,
  }

  await httpClient.put('/tennants/configs/points', payload)
}
